<button mat-button (click)="openPhotoDialog()">
  {{ "components.upload-pictures.open-picture-dialog-button" | translate }}
</button>
<div>
  <button mat-button (click)="fileInput.click()">
    {{
      "components.upload-pictures.upload-picture-from-device-button" | translate
    }}
  </button>
  <input
    #fileInput
    id="picture-file-input"
    type="file"
    accept="image/*"
    aria-label="Bild hochladen"
    (change)="onFileSelected($event)"
    style="display: none"
  />
</div>
<div class="scroll-container">
  @for (image of imagesWithDescription; track image; let i = $index) {
    <div>
      <div class="scroll-container-element">
        <mat-card appearance="outlined">
          <button mat-icon-button (click)="delete(i)" class="close-button">
            <mat-icon>close</mat-icon>
          </button>
          <img mat-card-image [src]="image.image" alt="Photo just taken!" />
          @if (image.description && image.description.length > 0) {
            <div>
              <mat-card-content class="description-container">
                <span>{{ image.description }}</span>
                <button mat-icon-button (click)="editDescription(i)">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              </mat-card-content>
            </div>
          } @else {
            <mat-card-actions>
              <button mat-button (click)="editDescription(i)">
                {{
                  "components.upload-pictures.add-description-button"
                    | translate
                }}
              </button>
            </mat-card-actions>
          }
        </mat-card>
      </div>
    </div>
  }
</div>
